'use strict';
$(document).ready(function () {
     $(document).on('change', '#numero_protocolo, #dt_nascimento,#nr_cns,#cpf', function () {
        validaListaSForma();
    })
    
});

function validaListaSForma(){
    if($('#numero_protocolo').val() !== '' || $('#dt_nascimento').val() !== '' || $('#nr_cns').val() !== '' || $('#cpf').val() !== ''){
        $('#tipo').attr('required',false);
        $('#sforma').attr('required',false);
    } else {
       $('#tipo').attr('required',true);
       $('#sforma').attr('required',true);   
    }
}

(function ($) {
    $.discover = function (value) {
        return typeof (value) === 'function' ? value() : value;
    };

    $.fn.async = function (options) {
        var element = $(this);
        var scope = $.extend({
            form: element,
            type: element.attr('method') || 'get',
            url: element.attr('action') || location.href,
            data: null,
            extra: null,
            ajax: {},
            to: null,
            start: function () {
            },
            end: function () {
            },
            success: function () {
            },
            error: function () {
            }
        }, options);
        var loader = function () {
            scope.start();
            var basis = scope.data ? $.param($.discover(scope.data)) : element.serialize();
            var extra = $.discover(scope.extra);
            extra = typeof (extra) === 'string' ? extra : $.param(extra);
            extra = (extra ? (basis.length ? '&' : '') + extra : '');
            element.next('.async-wrapper').remove();
            $.ajax($.extend({
                url: scope.url,
                type: scope.type,
                async: true,
                cache: false,
                contentType: 'application/x-www-form-urlencoded',
                data: basis + extra,
                complete: function (ajax, result) {
                    scope.end(ajax, result, {scope: scope});
                },
                error: function (xhr, desc, err) {
                    scope.error(xhr, desc, err, {scope: scope});
                }
            }, scope.ajax, {
                success: function (context) {
                    element.next('.async-wrapper').remove();
                    if (!scope.to || !scope.to.parent().length) {
                        scope.to = $('<div></div>').addClass('async-wrapper');
                        element.after(scope.to);
                    }
                    scope.to.html(context);
                    scope.success.apply(scope, arguments);
                }
            }));
        };
        element.on('submit', function (event) {
            event.preventDefault();
            loader();
        });
        return loader;
    };
})(jQuery);


$(function () {
    var $tipo = $('select[name="tipo"]');
    var $sforma = $('select[name="sforma"]');
    var $form = $('form#consulta_lista_de_espera');


    /*
     * Utiliza o formulário para carregar informações
     */
    window.load = $form.async({
        url: '/consultalistadeespera/lista',
        start: function () {
            $('.msg-error').remove();
            $('#loader').remove();
            $form.find('[name="submit"]').closest('dt').after('<img id="loader" src="/img/ajax-loader-flower.gif" />');
        },
        end: function () {
            $('#loader').remove();
        },
        error: function (xhr, desc, err) {
            $('.msg-error').remove();
            var erro = trata_erro_2(xhr.responseText, '', '');
            $('#content').prepend('<div class="msg-error"><h3>ERRO:</h3>' + erro + '</div>');
            return false;
        },
        success: function (data) {

        },
        extra: function () {
            return $('#gridFiltrolistaesperapublica').serialize();
        },
        to: null
    });


    /*
     * Carrega as Especialidade (especialidades) de acordo com o tipo.
     */
    $tipo.change(function () {
        if ($tipo.val().length && $.isNumeric($tipo.val())) {
            $.ajax({
                url: '/consultalistadeespera/subforma/tipo/' + $tipo.val(),
                type: 'GET',
                cache: false,
                dataType: 'JSON',
                beforeSend: function () {
                    $('.async-wrapper').remove();
                    $('#loader').remove();
                    $sforma.after('<img id="loader" src="/img/ajax-loader-flower.gif" />');
                    $sforma.find('*').remove();
                    $('.msg-error').remove();
                },
                complete: function () {
                    $('#loader').remove();
                },
                success: function (sformas) {
                    $sforma.removeAttr('disabled');
                    $sforma.append(
                            $('<option></option>', {
                                value: '',
                                title: 'Selecione a especialidade'
                            }).text('Selecione a especialidade')
                            );
                    for (var key in sformas) {
                        $sforma.append(
                                $('<option></option>', {
                                    value: sformas[key].id,
                                    title: sformas[key].description
                                }).text(sformas[key].description)
                                );
                    }
                },
                error: function (xhr, desc, err) {
                    $('.msg-error').remove();
                    var erro = trata_erro_2(xhr.responseText, '', '');
                    $('#content').append('<div class="msg-error"><h3>ERRO:</h3>' + erro + '</div>');
                    return false;
                }
            });
        }
        else {
            $sforma.attr('disabled', true).val('');
        }
    });


    $sforma.change(function () {
        $('.async-wrapper').remove();
    });
});